module.exports = __webpack_public_path__ + "img/solution3_chart3.c4e09c01.png";